// Traductions de base — Français (langue de référence)
export default {
  // ── Commun ──
  'common.save': 'Enregistrer',
  'common.cancel': 'Annuler',
  'common.delete': 'Supprimer',
  'common.edit': 'Modifier',
  'common.confirm': 'Confirmer',
  'common.close': 'Fermer',
  'common.search': 'Rechercher',
  'common.loading': 'Chargement...',
  'common.error': 'Erreur',
  'common.retry': 'Réessayer',
  'common.add': 'Ajouter',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.all': 'Tous',
  'common.yes': 'Oui',
  'common.no': 'Non',

  // ── Navigation publique (page d'accueil Zifek) ──
  'home.nav_features': 'Fonctionnalités',
  'home.nav_how': 'Comment ça marche',
  'home.nav_pricing': 'Tarifs',
  'home.nav_faq': 'FAQ',
  'home.create_site': 'Créer mon site',
  'home.my_space': 'Mon espace Zifek',
  'home.logout': 'Déconnexion',

  // ── Connexion / inscription ──
  'auth.login': 'Connexion',
  'auth.register': 'Inscription',
  'auth.client_space': 'Espace client',
  'auth.client_space_desc': 'Mes achats, mes fichiers',
  'auth.pro_space': 'Espace professionnel',
  'auth.pro_space_desc': 'Gérer ma boutique',

  // ── Navigation du tableau de bord marchand ──
  'dash.dashboard': 'Tableau de bord',
  'dash.products': 'Produits',
  'dash.caisse': 'Ma caisse',
  'dash.services': 'Services',
  'dash.orders': 'Commandes',
  'dash.customers': 'Clients',
  'dash.credit': 'Crédit',
  'dash.payments': 'Paiements',
  'dash.wallet': 'Portefeuille',
  'dash.store': 'Ma boutique',
  'dash.my_website': 'Mon siteweb',
  'dash.site_content': 'Contenu du site',
  'dash.media': 'Médias',
  'dash.documents': 'Documents',
  'dash.storage': 'Stockage',
  'dash.analytics': 'Statistiques',
  'dash.appstore': 'AppStore',
  'dash.apps': 'Mes Apps',
  'dash.themestore': 'ThemeStore',
  'dash.settings': 'Paramètres',
  'dash.account': 'Mon compte',
  'dash.profile': 'Mon profil',
  'dash.install_app': "Installer l'app",
  'dash.my_qr': 'Mon QR Zifek',
  'dash.logout': 'Déconnexion',
  'dash.notifications': 'Notifications',
  'dash.preview_site': 'Prévisualiser',
  'dash.view_site': 'Voir le site',

  // ── Navigation SuperAdmin ──
  'sa.dashboard': 'Tableau de bord',
  'sa.users': 'Utilisateurs',
  'sa.core': 'Zifek Core',
  'sa.themes': 'Theme Builder',
  'sa.apps': 'App Builder',
  'sa.homepage': "Page d'accueil",
  'sa.translations': 'Langues & Traductions',
  'sa.support': 'Support client',
  'sa.logs': 'Logs Système',
  'sa.accountTypes': 'Types de compte',
  'sa.database': 'Base de données & API',
  'sa.storage': 'Stockage',
  'sa.settings': 'Paramètres IA',

  // ── Service client ──
  'support.title': 'Service Client & Support',
  'support.new_ticket': 'Nouveau ticket',
  'support.subject': 'Sujet',
  'support.message': 'Message',
  'support.send': 'Envoyer',
  'support.reply': 'Répondre',
  'support.status': 'Statut',
  'support.open': 'Ouvert',
  'support.in_progress': 'En cours',
  'support.resolved': 'Résolu',
  'support.closed': 'Fermé',
  'support.zifek_team': 'Équipe Zifek',
  'support.contact_team': "Contacter l'équipe Zifek",
  'support.my_requests': 'Mes demandes',

  // ── Zifek Crédit ──
  'credit.title': 'Zifek Crédit',
  'credit.carnet': 'Carnet',
  'credit.clients': 'Clients',
  'credit.reports': 'Rapports',
  'credit.settings': 'Réglages',
  'credit.add_credit': 'Ajouter un crédit',
  'credit.record_payment': 'Enregistrer un paiement',
  'credit.balance': 'Solde',
  'credit.new_customer': 'Client',
  'credit.import_photo': 'Photo dettes',
  'credit.scan': 'Scanner',

  // ── Langue ──
  'lang.change': 'Changer de langue',

  // ── Pages métier : Crédit ──
  'credit.subtitle': 'Votre carnet de crédit numérique',
  'credit.tab.carnet': 'Carnet',
  'credit.tab.clients': 'Clients',
  'credit.tab.rapports': 'Rapports',
  'credit.tab.reglages': 'Réglages',
  'credit.photo_debts': 'Photo dettes',
  'credit.add_credit_btn': 'Ajouter un crédit',
  'credit.search_client': 'Rechercher un client...',
  'cr.qa_payment': 'Enregistrer un paiement',
  'cr.qa_add_client': 'Ajouter un client',
  'cr.qa_import_photo': 'Importer par photo',
  'cr.qa_invite': 'Inviter un client',
  'cr.qa_statement': 'Générer un relevé',
  'cr.qa_carnet': 'Carnet complet',

  // ── Pages métier : Caisse ──
  'caisse.title': 'Ma caisse',
  'caisse.subtitle': 'Caisse enregistreuse',
  'caisse.search': 'Rechercher un produit...',
  'caisse.cart': 'Panier',
  'caisse.empty': 'Panier vide',
  'caisse.checkout': 'Encaisser',
  'caisse.new_sale': 'Nouvelle vente',
  'caisse.subtotal': 'Sous-total',
  'caisse.tax': 'TVA',
  'caisse.total': 'Total',
  'caisse.cash': 'Espèces',
  'caisse.card': 'Carte',
  'caisse.paid': 'Paiement accepté',

  // ── Pages métier : Produits & Rapports ──
  'products.title': 'Produits',
  'products.subtitle': 'Gérez votre catalogue de produits',
  'products.new': 'Nouveau produit',
  'products.categories': 'Catégories',
  'products.catalog': 'Catalogue',
  'products.stock_mgmt': 'Gestion de stock',
  'products.search': 'Rechercher un produit...',
  'reports.title': 'Rapports',

  // ── Devise & rappels ──
  'currency.change': 'Changer de devise',
  'currency.equiv': 'équivaut à',
  'credit.enable_reminders': 'Activez les rappels de crédit',

  // ── Pages métier : Commandes ──
  'orders.title': 'Commandes',
  'orders.subtitle': 'Suivez et gérez toutes les commandes',
  'orders.filter_all': 'Toutes',
  'orders.filter_pending': 'En attente',
  'orders.filter_paid': 'Payées',
  'orders.filter_processing': 'Traitement',
  'orders.filter_shipped': 'Expédiées',
  'orders.filter_delivered': 'Livrées',
  'orders.empty': 'Aucune commande',
  'orders.empty_hint': 'Les commandes apparaîtront ici quand vous en recevrez',
  'orders.items': 'Articles',
  'orders.subtotal': 'Sous-total',
  'orders.shipping': 'Livraison',
  'orders.tax': 'Taxes',
  'orders.discount': 'Remise',
  'orders.total': 'Total',
  'orders.status': 'Statut',
  'orders.payment': 'Paiement',
  'orders.email': 'Email',
  'orders.phone': 'Téléphone',

  // ── Pages métier : Paiements ──
  'payments.title': 'Paiements',
  'payments.subtitle': 'Historique des transactions et revenus',
  'payments.received': 'Reçus',
  'payments.sent': 'Envoyés',
  'payments.balance': 'Solde actuel',
  'payments.filter_all': 'Toutes',
  'payments.filter_received': 'Reçues',
  'payments.filter_sent': 'Envoyées',
  'payments.empty': 'Aucune transaction',
  'payments.empty_hint': 'Les transactions apparaîtront ici',
  'payments.col_type': 'Type',
  'payments.col_amount': 'Montant',
  'payments.col_details': 'Détails',
  'payments.col_origin': 'Provenance',
  'payments.col_date': 'Date',
  'payments.in': 'Reçu',
  'payments.out': 'Envoyé',

  // ── Pages métier : Portefeuille ──
  'wallet.title': 'Portefeuille',
  'wallet.subtitle': 'Votre solde, vos recharges et l’historique de vos opérations.',
  'wallet.available': 'Solde disponible',
  'wallet.recharge': 'Recharger le portefeuille',
  'wallet.via_paypal': 'Recharger via PayPal',
  'wallet.via_stripe': 'Recharger via Stripe',
  'wallet.history': 'Historique des opérations',
  'wallet.empty': 'Aucune opération pour le moment.',
  'wallet.col_type': 'Type',
  'wallet.col_amount': 'Montant',
  'wallet.col_method': 'Méthode',
  'wallet.col_details': 'Détails',
  'wallet.col_date': 'Date',
  'wallet.type_recharge': 'Recharge',
  'wallet.type_refund': 'Remboursement',
  'wallet.type_debit': 'Débit',
  'wallet.method_wallet': 'Portefeuille',
  'wallet.method_admin': 'Administrateur',

  // ── Pages métier : Paramètres ──
  'settings.title': 'Paramètres',
  'settings.subtitle': 'Gérez votre compte et vos préférences',
  'settings.tab_profile': 'Profil',
  'settings.tab_password': 'Mot de passe',
  'settings.tab_domain': 'Domaine',
  'settings.tab_appearance': 'Apparence',
  'settings.tab_danger': 'Zone danger',

  // ── Crédit : formulaires longs ──
  'crf.tx_add_credit': 'Ajouter un crédit',
  'crf.tx_record_payment': 'Enregistrer un paiement',
  'crf.tx_adjustment': 'Ajustement',
  'crf.tx_hint_credit': 'Montant que le client vous doit en plus',
  'crf.tx_hint_payment': 'Montant que le client vous rembourse',
  'crf.tx_hint_adjustment': 'Correction (montant négatif pour réduire la dette)',
  'crf.current_balance': 'Solde actuel',
  'crf.amount': 'Montant',
  'crf.description': 'Description',
  'crf.description_credit_ph': 'Ex : sac de riz, huile…',
  'crf.description_payment_ph': 'Ex : paiement partiel',
  'crf.payment_method': 'Moyen de paiement',
  'crf.new_balance': 'Nouveau solde',
  'crf.confirm': 'Confirmer',
  'crf.saving': 'Enregistrement...',
  'crf.invalid_amount': 'Saisissez un montant valide.',
  'crf.save_error': "Erreur lors de l'enregistrement",
  'crf.edit_customer': 'Modifier le client',
  'crf.new_customer': 'Nouveau client',
  'crf.customer_name': 'Nom du client',
  'crf.customer_name_ph': 'Ex : Mohammed Alami',
  'crf.customer_hint': 'Aucun compte Zifek requis. Le client pourra être invité plus tard pour suivre son solde.',
  'crf.phone_optional': 'Téléphone (optionnel)',
  'crf.credit_limit_optional': 'Plafond de crédit (optionnel)',
  'crf.usual_payment_date': 'Date de paiement habituelle',
  'crf.not_defined': 'Non définie',
  'crf.day_of_month': 'Le {day} du mois',
  'crf.notes_optional': 'Notes (optionnel)',
  'crf.notes_ph': 'Ex : voisin du quartier, paie fin de mois…',
  'crf.name_required': 'Le nom du client est obligatoire.',
  'crf.create_customer': 'Créer le client',
  'crf.client_access': 'Accès client',
  'crf.client_access_desc': "Voici les identifiants du client. Partagez-les avec lui : il pourra se connecter à son espace client pour suivre son solde et son historique.",
  'crf.username': 'Identifiant',
  'crf.default_password': 'Mot de passe par défaut',
  'crf.client_space': 'Espace client',
  'crf.share': 'Partager',
  'crf.regen_password': 'Régénérer un mot de passe',
  'crf.creds_hint': 'Le client peut aussi changer ce mot de passe depuis son espace.',
  'crf.import_title': 'Importer les dettes par photo',
  'crf.import_sub_upload': 'Photographiez la page du cahier',
  'crf.import_sub_confirm': 'Confirmation requise',
  'crf.import_sub_review': 'Vérifiez puis validez',
  'crf.import_desc': "Prenez une ou plusieurs photos de la page du cahier (noms + montants). L'IA lit ensuite les dettes et vous les présente pour validation. Rien n'est enregistré avant votre confirmation.",
  'crf.take_photos': 'Prendre / choisir des photos',
  'crf.photos_hint': "Jusqu'à 8 photos · JPG, PNG",
  'crf.import_history': "Historique des imports",
  'crf.import_cancelled': 'Annulé',
  'crf.cancel_btn': 'Annuler',
  'crf.revert_hint': 'Annuler un import supprime les dettes créées (et les clients créés par cet import).',
  'crf.add_line': 'Ajouter une ligne',
  'crf.detected_total': '{count} dette(s) détectée(s) · total {total}',
  'crf.debt_detail_ph': 'Détail (ex : 2 sacs de farine, pain…)',
  'crf.existing_customer_tag': 'Client existant — la dette sera ajoutée à son compte',
  'crf.no_debt': 'Aucune dette. Ajoutez une ligne manuellement.',
  'crf.ai_read_none': "L'IA n'a lu aucune dette sur ces photos. Essayez avec une photo plus nette et bien éclairée.",
  'crf.ai_failed': "Échec de l'analyse IA",
  'crf.add_at_least_one': 'Ajoutez au moins une dette avec un nom et un montant.',
  'crf.confirm_existing_title': 'Client(s) déjà existant(s)',
  'crf.confirm_existing_desc': "Ces noms existent déjà dans votre carnet. Confirmez-vous l'ajout de ces dettes sur leurs comptes existants ?",
  'crf.new_clients_count': '{count} nouveau(x) client(s) seront aussi créés.',
  'crf.creating_progress': 'Création des clients et des dettes... {done}/{total}',
  'crf.analyse_ai': "Analyser avec l'IA",
  'crf.reading_ai': "Lecture par l'IA...",
  'crf.back': 'Retour',
  'crf.validate_create': 'Valider et créer',
  'crf.confirm_add_existing': 'Confirmer et ajouter aux comptes existants',
  'crf.import_failed': "Échec de l'import",
  'crf.revert_failed': "Échec de l'annulation",
  'crf.revert_question': 'Annuler cet import ?',
  'crf.revert_desc': '{count} dette(s) supprimée(s).',
  'crf.currency': 'Devise',
  'crf.currency_desc': 'Utilisée sur tout le carnet de crédit.',
  'crf.default_due_day': "Jour d'échéance par défaut",
  'crf.no_due_day': 'Non défini',
  'crf.reminders': 'Rappels',
  'crf.reminders_desc': "Les rappels sont envoyés à votre client via son application Zifek (PWA), s'il l'a installée. S'il ne l'a pas installée, aucun rappel automatique n'est envoyé.",
  'crf.reminder_new_credit': 'Nouveau crédit',
  'crf.reminder_payment': 'Confirmation de paiement',
  'crf.reminder_balance': 'Solde courant',
  'crf.reminder_due_date': 'Échéance à venir',
  'crf.reminder_monthly': 'Relevé mensuel',
  'crf.default_channel': 'Canal par défaut',
  'crf.channel_inapp': 'App client (PWA)',
  'crf.merchant_qr': "QR d'invitation marchand",
  'crf.merchant_qr_desc': 'Affichez ce code en caisse. Vos clients connectés à Zifek le scannent pour lier leur compte à votre carnet.',
  'crf.show_qr': 'Afficher le QR',
  'crf.last_reminders': 'Derniers rappels',
  'crf.save_settings': 'Enregistrer les réglages',
  'crf.saved': 'Enregistré !',
  'crf.qr_client': 'QR client',
  'crf.merchant_invite': 'Invitation marchand',
  'crf.link_customer': 'Lien de rattachement client',
  'crf.to_pay': 'à payer',
  'crf.up_to_date': 'à jour',
  'crf.limit_badge': 'Plafond',
  'crf.no_phone': 'Sans téléphone',
  'crf.ledger_empty_title': 'Votre carnet est vide',
  'crf.ledger_empty_desc': 'Ajoutez un client puis enregistrez un crédit en quelques secondes — comme sur un carnet, mais sans le papier.',
  'crf.add_customer': 'Ajouter un client',
  'crf.no_client_found': 'Aucun client trouvé',
  'crf.export_csv': 'Exporter CSV',
  'crf.no_customer': 'Aucun client enregistré',
  'crf.col_client': 'Client',
  'crf.col_balance': 'Solde',
  'crf.col_limit': 'Plafond / dispo.',
  'crf.col_due': 'Échéance',
  'crf.col_actions': 'Actions',
  'crf.no_limit': 'Aucun plafond',
  'crf.available_short': 'dispo.',
  'crf.linked_account': 'Compte lié',
  'crf.last_activity': 'dernier',
  'crf.tooltip_add_credit': 'Ajouter un crédit',
  'crf.tooltip_payment': 'Paiement',
  'crf.tooltip_invite': 'Inviter sur Zifek',
  'crf.tooltip_credentials': 'Voir les identifiants',
  'crf.tooltip_edit': 'Modifier',
  'crf.tooltip_delete': 'Supprimer',
  'crf.stat_outstanding': 'Crédit total en cours',
  'crf.stat_with_credit': 'Clients avec crédit',
  'crf.stat_credits_month': 'Crédits ce mois',
  'crf.stat_payments_month': 'Paiements reçus ce mois',
  'crf.stat_attention': 'Clients à surveiller',
  'crf.rep_export_balances': 'Soldes CSV',
  'crf.rep_export_history': 'Historique CSV',
  'crf.rep_from': 'Du',
  'crf.rep_to': 'Au',
  'crf.rep_reset': 'Réinitialiser',
  'crf.rep_credits_period': 'Crédits (période)',
  'crf.rep_payments_period': 'Paiements (période)',
  'crf.rep_adjust_period': 'Ajustements (période)',
  'crf.rep_credits_vs_payments': 'Crédits vs paiements',
  'crf.rep_last_6': '6 derniers mois',
  'crf.rep_credits': 'Crédits',
  'crf.rep_payments': 'Paiements',
  'crf.rep_client_balances': 'Soldes clients',
  'crf.rep_no_balance': 'Aucun solde en cours',
  'crf.rep_payment_history': 'Historique des paiements',
  'crf.rep_no_payment': 'Aucun paiement sur la période',
  'crf.rep_deleted_client': 'Client supprimé',
  'crf.rep_type_credit': 'Crédit',
  'crf.rep_type_payment': 'Paiement',
  'crf.rep_type_adjust': 'Ajustement',

  // ── Caisse : formulaires longs ──
  'csf.all_categories': 'Tous',
  'csf.no_result': 'Aucun résultat',
  'csf.no_active_product': 'Aucun produit actif',
  'csf.try_other': 'Essayez un autre terme',
  'csf.add_active_hint': 'Ajoutez des produits avec le statut "Actif"',
  'csf.out_of_stock': 'Rupture',
  'csf.remaining': 'restant(s)',
  'csf.promo': 'Promo',
  'csf.clear': 'Vider',
  'csf.click_to_add': "Cliquez sur un produit pour l'ajouter au panier",
  'csf.cash_payment': 'Paiement en espèces',
  'csf.card_payment': 'Paiement par carte',
  'csf.amount_to_pay': 'Montant à payer',
  'csf.amount_received': 'Montant reçu',
  'csf.change_to_give': 'Monnaie à rendre',
  'csf.insert_card': 'Insérez ou passez la carte',
  'csf.terminal_hint': 'Terminal connecté · Paiement sans contact accepté',
  'csf.insufficient': 'Le montant reçu est insuffisant.',
  'csf.processing': 'Encaissement...',
  'csf.validate_payment': 'Valider le paiement',
  'csf.back': 'Retour',
  'csf.payment_accepted': 'Paiement accepté',
  'csf.order': 'Commande',
  'csf.articles': 'Articles',
  'csf.payment_method': 'Mode de paiement',
  'csf.cash_label': 'Espèces',
  'csf.card_label': 'Carte bancaire',
  'csf.change_label': 'Monnaie rendue',
  'csf.new_sale': 'Nouvelle vente',
  'csf.check_access': "Vérification de l'accès...",
  'csf.load_error': 'Erreur chargement produits',
  'csf.sale_offline_error': "Impossible d'enregistrer la vente hors ligne",
  'csf.sale_error': "Erreur lors de l'encaissement",

  // ── Produits : formulaires longs ──
  'prf.new_title': 'Nouveau produit',
  'prf.new_subtitle': 'Ajoutez un produit à votre catalogue',
  'prf.edit_title': 'Modifier le produit',
  'prf.created': 'Produit créé avec succès !',
  'prf.updated': 'Produit mis à jour avec succès !',
  'prf.uploading_media': 'Téléchargement des médias en cours...',
  'prf.general_info': 'Informations générales',
  'prf.product_name': 'Nom du produit',
  'prf.product_name_ph': 'Ex: T-shirt Premium',
  'prf.description': 'Description',
  'prf.description_ph': 'Décrivez votre produit...',
  'prf.category': 'Catégorie',
  'prf.no_category': 'Aucune catégorie',
  'prf.status': 'Statut',
  'prf.status_draft': 'Brouillon',
  'prf.status_active': 'Actif',
  'prf.status_inactive': 'Inactif',
  'prf.price': 'Prix',
  'prf.stock': 'Stock',
  'prf.enable_promo': 'Activer la promotion',
  'prf.promo_price': 'Prix promotionnel',
  'prf.media': 'Médias',
  'prf.cover_image': 'Image de couverture',
  'prf.click_drag_image': 'Cliquez ou glissez une image',
  'prf.click_drag_video': 'Cliquez ou glissez une vidéo',
  'prf.additional_images': 'Images supplémentaires',
  'prf.add': 'Ajouter',
  'prf.short_video': 'Vidéo courte',
  'prf.variants': 'Variantes',
  'prf.has_variants': 'Ce produit a des variantes (tailles, couleurs...)',
  'prf.variant_type_ph': 'Type (ex: Taille)',
  'prf.variant_options_ph': 'Options (ex: S, M, L)',
  'prf.add_variant_type': 'Ajouter un type de variante',
  'prf.pricing': 'Tarification :',
  'prf.single_price': 'Prix unique',
  'prf.per_variant': 'Prix par variante',
  'prf.combination': 'Combinaison',
  'prf.generated_combos': 'Combinaisons générées',
  'prf.create_product': 'Créer le produit',
  'prf.save': 'Enregistrer',
  'prf.saving': 'Enregistrement...',
  'prf.creating': 'Création...',
  'prf.cancel': 'Annuler',
  'prf.name_required': 'Le nom est requis',
  'prf.invalid_price': 'Prix invalide',
  'prf.invalid_stock': 'Stock invalide',
  'prf.invalid_promo': 'Prix promo invalide',
  'prf.image_url': 'Image (URL)',
  'prf.view_details': 'Voir détails',
  'prf.edit_btn': 'Modifier',
  'prf.uploading': 'Téléchargement...',
} as Record<string, string>;